import styled from "styled-components";
import { fonts } from "theme/fonts";

export const ButtonPrimary = ({
  as,
  href,
  className,
  onClick,
  target,
  rel,
  children,
}) => {
  return (
    <Wrapper
      as={as}
      href={href}
      className={className}
      onClick={onClick}
      target={target}
      rel={rel}
    >
      <span>{children}</span>
    </Wrapper>
  );
};

const Wrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 40px;
  border: 0px;
  background-color: #fff;
  color: #951c2b;
  font-family: aktiv-grotesk-extended, sans-serif;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 700;
  outline: 0;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  border-radius: 25px;
  text-transform: uppercase;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.1);

  &:hover {
  }

  & > span {
    /* height: 1.2rem; */
  }
`;
